import React from "react";
import Link from "gatsby-link";
import { Container, Row, Col, Visible, Hidden, ScreenClassRender } from 'react-grid-system';
import "./Listing.css";

class PostListing extends React.Component {
  getPostList() {
    const postList = [];
    this.props.postEdges.forEach(postEdge => {
      postList.push({
        path: postEdge.node.fields.slug,
        tags: postEdge.node.frontmatter.tags,
        cover: postEdge.node.frontmatter.cover,
        title: postEdge.node.frontmatter.title,
        date: postEdge.node.frontmatter.date,
        excerpt: postEdge.node.excerpt,
        timeToRead: postEdge.node.timeToRead
      });
    });
    return postList;
  }
  render() {
    const postList = this.getPostList();
    return (
        <Row>
        {/* Your post list here. */
        postList.map(post =>
            <Col md={4}>
              <Link to={post.path} key={post.title}><img src={post.cover} /></Link>
              <h3 className="feed-title"><Link to={post.path} key={post.title}>{post.title}</Link></h3>
            </Col>
        )}
        </Row>
    );
  }
}

export default PostListing;



// WEBPACK FOOTER //
// ./src/components/PostListing/PostListing.jsx